import { QueryClient } from "@tanstack/react-query"
import { THREE_MINUTES } from "./react-query.lib"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: THREE_MINUTES,
    },
  },
})
